import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';

class PublicRoute extends React.Component {
  render() {
    const { component: Component, isLoggedIn, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={props =>
          isLoggedIn ? (
            <Redirect
              to={{
                pathname: '/',
                state: { from: props.location }
              }}
            />
          ) : (
            <Component {...props} />
          )
        }
      />
    );
  }
}

function mapStateToProps(state) {
  return { ...state.authentication };
}
export default connect(mapStateToProps)(PublicRoute);
